import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
// Crypto Redux States
import { TasksTypes } from './actionTypes';
import {
  getTasksSuccess,
  getTasksFail,
  addTasksFail,
  addTasksSuccess,
  deleteTasksSuccess,
  deleteTasksFail,
  updateTasksFail,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';

export const fetchTasks = async (data: any) => {
  const { sizePerPage, page } = data?.pagination ?? {
    sizePerPage: 50,
    page: 1,
  };

  let textClient = '';
  let textDescripcion = '';

  if (data && data.data) {
    textClient = data.data['Search Client ID'];
    textDescripcion = data.data['Search Descripcion'];
  }

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const path = url.API_URL;
  const query = `query {
    Tasks (
        Pagination:{
            sizePage:${sizePerPage},
            actualPage:${page},
        },
        order:"${data?.data?.order ?? "{'id': 'ASC'}"}",
        filter:{
          ${textClient ? `clienteId: ${textClient}` : ''}
          ${textDescripcion ? `descripcion: "${textDescripcion}"` : ''}
        },
        FilterEmpresaID:{
          ${user.id ? `userId: ${user.id}` : ''}
        }
        ) {
            taskData {
                id
                empresa
                clienteId
                descripcion
                enabled
                code      
            }   
            CountItems
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.Tasks;
};

function* getTasksSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchTasks, data.payload);
    yield put(getTasksSuccess(response));
  } catch (error) {
    yield put(getTasksFail(error));
  }
}

export const addTasksList = async ({ payload: { tasksAdd } }: any) => {
  const { empresa, clienteId, descripcion, enabled, code } = tasksAdd.tasks;
  const query = `mutation {  
    createTasks( Tasks:  {
        empresa: ${empresa},
        clienteId:${clienteId},
        descripcion:"${descripcion}",
        enabled:${enabled},
        code:${JSON.stringify(code)},
    })    
    {
        id
        empresa
        clienteId
        descripcion
        enabled
        code
      }
  }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return respon.data;
};

function* addTasksSaga(task: any) {
  const { pagination } = task.payload.tasksAdd;
  try {
    const response: Promise<any> = yield call(addTasksList, task);
    yield put(addTasksSuccess(response));

    const response2: Promise<any> = yield call(fetchTasks, task);
    yield put(getTasksSuccess(response2));
  } catch (error) {
    yield put(addTasksFail(error));
  }
}

export const deleteTasksList = async (id: any) => {
  const path = url.API_URL;
  const query = `mutation{
    deleteTasks(Tasks: {
      id: ${id}
     })
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.deleteTasks;
};

function* deleteTasksSaga({ payload }: any) {
  const { id, pagination } = payload;
  try {
    const response: Promise<any> = yield call(deleteTasksList, id);
    yield put(deleteTasksSuccess(response));
    const response2: Promise<any> = yield call(fetchTasks, {
      pagination,
      data: payload.data,
    });
    yield put(getTasksSuccess(response2));
  } catch (error) {
    console.log(error);
    yield put(deleteTasksFail(error));
  }
}

function* updateTasksList(action: any): any {
  const { payload } = action;
  const { pagination } = payload.tasks;
  const path = url.API_URL;
  const { id, empresa, clienteId, descripcion, enabled, code } =
    payload.tasks.tasks;

  const query = `mutation {  
    updateTasks ( Tasks:  {
        id: ${id},
        empresa: ${empresa},
        clienteId:${clienteId},
        descripcion:"${descripcion}",
        enabled:${enabled},
        code:${JSON.stringify(code)},
    })    
    {
        id
        empresa
        clienteId
        descripcion
        enabled
        code
      }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };
    console.log( action )
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resp: any = yield call(apiFetch, path, opts);
    
    const response: Promise<any> = yield call(fetchTasks, {
      pagination,
      data: payload.tasks.data,
    });
    yield put(getTasksSuccess(response));
  } catch (error) {
    yield put(updateTasksFail(error));
  }
}

function* TasksSaga() {
  yield takeEvery(TasksTypes.GET_TASKS, getTasksSaga);
  yield takeEvery(TasksTypes.ADD_TASKS, addTasksSaga);
  yield takeEvery(TasksTypes.DELETE_TASKS, deleteTasksSaga);
  yield takeLatest(TasksTypes.UPDATE_TASKS, updateTasksList);
}

export default TasksSaga;
